var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header-container"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),(_vm.button)?_c('Button',{attrs:{"className":"--primary --outline --mini --wider","onclick":_vm.onclick}},[_vm._v(_vm._s(_vm.button))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }